import PrizesWrapper from './PrizesWrapper';

export default PrizesWrapper;
